module.exports = __webpack_public_path__ + "media/V72.d806077d.mp4";